module.exports = __webpack_public_path__ + "img/address.3c3d2a92.png";